<template>
    <div :style="{ top: '0', zIndex: 1000 }" class="wrapper">
        <div class="header">
            <button class="btnClose" :style="{ margin: `10px` }" v-on:click="closeModal">
                <CloseSVG />
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M14 1.4L12.6 0L7 5.6L1.4 0L0 1.4L5.6 7L0 12.6L1.4 14L7 8.4L12.6 14L14 12.6L8.4 7L14 1.4Z"
                        fill="#999999" />
                </svg>

            </button>
        </div>
        <div :class="customClass">
            <slot></slot>
        </div>
    </div>
</template>
    
<script>
import { CloseSVG } from '@/components/utils/svg';
export default {
    name: 'ModalPlayerLayout',
    components: {
        CloseSVG
    },
    props: {
        closeModal: {
            type: Function
        },
        customClass: {
            type: String,
            default() {
                return "body"
            }
        }
    },
}
</script>
  
<style>
.wrapper {
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    height: 100%;
    width: 98%;
    background: rgba(var(--vm-controls-bg-vars), .86);
    padding: 0px;
}

.wrapper .header {
    display: flex;
}

.wrapper .header .btnClose {
    margin-left: auto;
}

.btnClose {
    height: 33px;
    width: 43px;
    border: unset;
    background-color: #fff !important;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: auto!important;
}

.btnClose svg {
    height: 14px;
    width: 14px;
}

@media screen and (max-width: 992px) {
    .wrapper {
        position: fixed;
        z-index: 51;
    }

    .wrapper .header .btnClose {
        margin-top: 5%;
    }
}

@media screen and (max-width: 576px) {
    .wrapper .header .btnClose {
        margin-top: 0;
    }
}
</style>